import React from "react";
import { useHistory } from "react-router-dom";
import { Text, Link, Card } from "@merge-api/merge-javascript-shared";
import { GET_IN_TOUCH_WITH_TRACKING_PATH } from "../../../../router/RouterUtils";
import { BillingPlanTier, LAUNCH_GUARDRAILS_LINKED_ACCOUNT_LIMIT } from "./BillingModels";
import { getBillingPlanTitle } from "./BillingUtils";
import {
  MERGE_BILLING_SELF_SERVE_HELP_ARTICLE_PATH,
  navigateToAddPaymentPage,
} from "../../../../router/RouterUtils";
import useLoadOrganizationBillingPlan from "./hooks/useLoadOrganizationBillingPlan";
import PlanCard from "./components/PlanCard";

function OldBillingPage() {
  const history = useHistory();
  const { organizationBillingPlan } = useLoadOrganizationBillingPlan();

  function getPlanSubtitle() {
    switch (organizationBillingPlan?.billing_plan?.plan_tier) {
      case BillingPlanTier.BILLING_PLAN_TIER_FREE:
        return `You can only connect 3 production and 3 test Linked Accounts on this plan. Any additional accounts you connect will not be synced. Upgrade your plan to link more accounts.`;
      case BillingPlanTier.BILLING_PLAN_TIER_LAUNCH:
        return (
          <>
            {`Up to ${LAUNCH_GUARDRAILS_LINKED_ACCOUNT_LIMIT} production Linked Accounts for
            $650/month. You will automatically incur a $65/month prorated fee for every production
            Linked Account past ${LAUNCH_GUARDRAILS_LINKED_ACCOUNT_LIMIT}. `}
            <a href={MERGE_BILLING_SELF_SERVE_HELP_ARTICLE_PATH} rel="noreferrer" target="_blank">
              Learn more
            </a>
            .
          </>
        );
      case BillingPlanTier.BILLING_PLAN_TIER_GROW:
        return "Premium";
      case BillingPlanTier.BILLING_PLAN_TIER_EXPAND:
        return "Enterprise";
    }
    return "";
  }

  return (
    <>
      <Card className="p-5">
        <Text variant="md" className="text-gray-40 mb-2">
          Current plan
        </Text>
        <Text variant="h3" className="font-semibold mb-2">
          {organizationBillingPlan ? getBillingPlanTitle(organizationBillingPlan) : "-"}
        </Text>
        <Text variant="md" className="text-gray-40">
          {getPlanSubtitle()}
        </Text>
      </Card>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mt-4">
        <PlanCard
          title="Launch"
          description="For development teams that want self-serve integrations in production"
          features={[
            "Get 3 production Linked Accounts for free",
            "Pay $650/month for up to 10 total production Linked Accounts",
            "Pay $65/month prorated fee for every production Linked Account past 10",
          ]}
          buttonText="Upgrade to Launch"
          onClick={() => navigateToAddPaymentPage(history, { fromUpgradeButton: true })}
        />

        <PlanCard
          title="Professional"
          description="For companies that want to power deep integration use cases"
          features={[
            "Access custom fields",
            "Field-level scopes for enhanced data minimization",
            "Custom sync frequencies",
            "60 day access to developer sandboxes for third-party platforms",
            "Access to go-live support packages",
          ]}
          buttonText="Contact us"
          onClick={() => window.open(GET_IN_TOUCH_WITH_TRACKING_PATH, "_blank")}
        />

        <PlanCard
          title="Enterprise"
          description="For large companies that want white-glove security, support, and infrastructure"
          features={[
            "Enterprise security features like Audit Trail",
            "Premium go-live support",
            "60 day access to sandboxes",
            "Dedicated account manager with shared Slack channel",
            "Support and uptime SLAs",
          ]}
          buttonText="Contact us"
          onClick={() => window.open(GET_IN_TOUCH_WITH_TRACKING_PATH, "_blank")}
        />
      </div>

      <div className="flex justify-center my-9">
        <Text className="text-center text-gray-40">
          Tired of painless integrations?{" "}
          <Link href="mailto:hello@merge.dev" className="text-red-60">
            Contact us to cancel your plan
          </Link>
        </Text>
      </div>
    </>
  );
}

export default OldBillingPage;
